import {
  StyledCard,
  StyledDescription,
  StyledIcon,
  StyledTitle,
} from "./Card.styles";

const CardComponent = ({
  icon = "🎂",
  onClick = () => {},
  title = "Birthday Party",
  description = "Host an unforgettable birthday celebration with our private theatre experience. Enjoy a personalised movie screening with friends and family in a cozy, exclusive setting",
}) => {
  return (
    <StyledCard onClick={onClick}>
      <StyledIcon>{icon}</StyledIcon> {/* Emoji or replace with an icon */}
      <div>
        <StyledTitle>{title}</StyledTitle>
        <StyledDescription>{description}</StyledDescription>
      </div>
    </StyledCard>
  );
};

export default CardComponent;
